import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { styled, MenuItem as MenuItem$1 } from "@mui/material";
import { e as MENU_ITEM_SIZE_DENSE, f as MENU_ITEM_SIZE_EXTENDED } from "./TablePaginationActions-CCDi-BO-.js";
const StyledMenuItem = styled(MenuItem$1, {
  shouldForwardProp: (prop) => !["subtitle", "destructive", "extended", "fixed", "iconColor"].includes(
    prop
  )
})(
  ({
    theme,
    dense,
    subtitle,
    destructive,
    extended,
    fixed,
    iconColor = "primary"
  }) => ({
    ...subtitle && {
      pointerEvents: "none",
      columnGap: 0,
      ...theme.typography.caption,
      fontWeight: 500,
      color: `${theme.palette.text.secondary} !important`,
      ".MuiListItemText-root .MuiTypography-root": {
        ...theme.typography.caption,
        fontWeight: 500,
        color: theme.palette.text.secondary
      },
      "&.MuiMenuItem-root": {
        minHeight: MENU_ITEM_SIZE_DENSE,
        paddingTop: 0,
        paddingBottom: 0,
        marginTop: theme.spacing(1),
        "&:not(:first-of-type)": {
          marginTop: theme.spacing(2),
          "&::before": {
            content: '""',
            position: "absolute",
            top: theme.spacing(-1),
            left: 0,
            right: 0,
            height: 1,
            backgroundColor: theme.palette.divider
          }
        }
      }
    },
    ...iconColor === "primary" && {
      ".MuiListItemIcon-root svg path": {
        fill: theme.palette.text.primary
      },
      "&.Mui-selected .MuiListItemIcon-root svg path": {
        fill: theme.palette.primary.main
      },
      '.MuiAutocomplete-listbox &[aria-selected="true"] svg path': {
        fill: theme.palette.primary.main
      }
    },
    ...destructive && {
      color: theme.palette.error.main,
      ".MuiTypography-root": {
        color: theme.palette.error.main
      },
      "svg, & .MuiSvgIcon-root": {
        color: theme.palette.error.main
      },
      ".MuiListItemIcon-root svg path": {
        fill: theme.palette.error.main
      },
      "&.Mui-selected .MuiListItemIcon-root svg path": {
        fill: theme.palette.error.main
      },
      "&:hover": {
        backgroundColor: theme.palette.error.relatedLight
      },
      "&.Mui-selected": {
        color: theme.palette.error.main,
        ".MuiTypography-root": {
          color: theme.palette.error.main
        },
        "svg, & .MuiSvgIcon-root": {
          color: theme.palette.error.main
        }
      },
      "&.Mui-disabled": {
        color: theme.palette.text.disabled,
        ".MuiTypography-root": {
          color: theme.palette.text.disabled
        },
        svg: {
          color: theme.palette.text.disabled
        }
      }
    },
    ...extended && {
      "&.MuiButtonBase-root.MuiMenuItem-root": {
        minHeight: MENU_ITEM_SIZE_EXTENDED
      }
    },
    ...fixed && {
      "&.MuiMenuItem-root": {
        position: "sticky",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 2,
        minHeight: MENU_ITEM_SIZE_EXTENDED,
        marginBottom: theme.spacing(1),
        padding: theme.spacing(0.5, 1.5),
        backgroundColor: `${theme.palette.background.paper} !important`,
        borderBottom: `1px solid ${theme.palette.divider}`
      },
      ".MuiAutocomplete-listbox &.MuiAutocomplete-option:first-of-type": {
        minHeight: MENU_ITEM_SIZE_EXTENDED,
        marginTop: 0,
        "&:hover": {
          backgroundColor: theme.palette.background.paper
        }
      }
    },
    ...!fixed && {
      ".MuiList-root &:first-of-type": {
        marginTop: theme.spacing(1)
      }
    },
    ...dense && {
      "&.MuiButtonBase-root.MuiMenuItem-root": {
        minHeight: MENU_ITEM_SIZE_DENSE,
        padding: theme.spacing(0.25, 1.5)
      }
    }
  })
);
function _MenuItem({
  disabled,
  subtitle,
  destructive,
  extended,
  fixed,
  iconColor = "primary",
  dense,
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(
    StyledMenuItem,
    {
      "data-name": "menu-item",
      ...props,
      ref,
      disabled: disabled || subtitle,
      subtitle,
      destructive,
      extended,
      dense,
      fixed,
      iconColor,
      "data-destructive": destructive,
      "data-extended": extended,
      "data-dense": dense,
      "data-fixed": fixed,
      "data-icon-color": iconColor
    }
  );
}
const MenuItem = forwardRef(_MenuItem);
export {
  MenuItem as M
};
